import { Controller } from "stimulus"

export default class extends Controller {
  submit(event) {
    event.target.form.dispatchEvent(new CustomEvent('submit', { bubbles: true }))
  }
}
